import React, { useState } from 'react';
import moment from 'moment';

export default function ErrorTable({ validatedCoupons }) {
  const [filterValue, setFilterValue] = useState('all');
  const rowsToShow = validatedCoupons.filter((c) =>
    filterValue === 'all' ? true : c.validationError.length > 0
  );
  return (
    <div className='bg-white'>
      <div className='items-center flex justify-between p-5 border-b-2 border-gray-500'>
        <h1 className='text-xl font-semibold text-gray-400'>Errors in sheet</h1>
        <select
          onChange={(e) => setFilterValue(e.target.value)}
          className='border border-gray-300 px-8 py-2 text-lg'
          value={filterValue}
        >
          <option value='all'>All</option>
          <option value='error'>Error</option>
        </select>
      </div>
      <div className='overflow-scroll' style={{ height: '30rem' }}>
        <table className='p-5'>
          <thead>
            <tr>
              <th className='border border-gray-500 p-3 bg-blue-200'>
                Coupon Code
              </th>
              <th className='border border-gray-500 p-3 bg-blue-200'>
                Discount Amount (in Paise)
              </th>
              <th className='border border-gray-500 p-3 bg-blue-200'>
                Goal Type
              </th>
              <th className='border border-gray-500 p-3 bg-blue-200'>
                Payment Mode
              </th>
              <th className='border border-gray-500 p-3 bg-blue-200'>
                Expiry Date
              </th>
              <th className='border border-gray-500 p-3 bg-blue-200'>Errors</th>
            </tr>
          </thead>
          <tbody>
            {rowsToShow.map((row, index) => (
              <tr
                key={index}
                className={
                  row.validationError.length > 0 ? 'bg-red-100' : 'bg-white'
                }
              >
                <td
                  data-tip={row.couponCode}
                  className='whitespace-nowrap truncate max-w-lg border border-gray-500 p-3'
                >
                  {row.couponCode}
                </td>
                <td
                  data-tip={row.discountAmount}
                  className='truncate max-w-sm border border-gray-500 p-3'
                >
                  {isNaN(row.discountAmount) === false &&
                    Number(row.discountAmount)}
                </td>
                <td
                  data-tip={row.goalType}
                  className='whitespace-nowrap truncate max-w-lg border border-gray-500 p-3'
                >
                  {row.goalType}
                </td>
                <td
                  data-tip={row.paymentMode}
                  className='truncate max-w-sm border border-gray-500 p-3'
                >
                  {row.paymentMode}
                </td>
                <td className='border border-gray-500 p-3'>
                  {row.expiryDate instanceof Date
                    ? moment(row.expiryDate).format('MM/DD/YYYY HH:mm:ss')
                    : row.expiryDate}
                </td>
                <td className='border border-gray-500 p-3 text-green-c2'>
                  {row.validationError.length > 0 && (
                    <span className='text-red-c1'>
                      {row.validationError.toString()}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
